import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { Reel } from '@/types/reel.type';
import { DataState, INITIAL_DATA_STATE } from '@/types/data.type';

import { ReelsSliceState } from './reels.type';

const reelsInitialState: ReelsSliceState = {
    dataState: INITIAL_DATA_STATE,
    data: [],
};

export const REELS_REDUCER_NAME = 'reels';

export const reelsSlice = createSlice({
    name: REELS_REDUCER_NAME,
    initialState: reelsInitialState,
    reducers: {
        setReels: (
            state,
            action: PayloadAction<{
                reels: Reel[];
            }>,
        ) => {
            state.data = action.payload.reels;
        },
        setReelName: (
            state,
            action: PayloadAction<{
                reelCode: string;
                name: string;
            }>,
        ) => {
            const reel = state.data.find(
                (reel) => reel.code === action.payload.reelCode,
            );

            if (reel) {
                reel.name = action.payload.name;
            }
        },
        setDataState: (
            state,
            action: PayloadAction<{
                dataState: DataState;
            }>,
        ) => {
            state.dataState = action.payload.dataState;
        },
    },
});

export const { setReels, setReelName, setDataState } = reelsSlice.actions;

export const reelsReducer = reelsSlice.reducer;
